import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface IUniversalDialog {
  title: string;
  description: string;
}

@Component({
  selector: 'demo-universal-modal-dialog',
  templateUrl: './universal-modal-dialog.component.html',
  styleUrls: ['./universal-modal-dialog.component.scss']
})
export class UniversalModalDialogComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<UniversalModalDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: IUniversalDialog,
  ) {}

  ngOnInit() {
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

}
